import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Button)`
  &.limitReached {
    opacity: 0.5;
  }
  &.Mui-disabled {
    & > svg {
      color: ${(p) => p.theme.palette.grey[400]};
    }
  }
`;
